import { themeClubbi } from 'clubbi-ui'
import { END_BLACK_FRIDAY, START_ESQUENTA_BF } from './utils'

export interface Seasonality {
  name: string
  imageHeaderDesktop?: string
  imageHeaderMobile?: string
  imageFlyer?: string
  imageFlyerFooter?: string
  backgroundColor?: string
  headerColor?: string
  hoverColor?: string
  footerColor?: string
  iconColor?: string
  shadow?: string
  dateTimeToStart: Date
  dateTimeToExpire: Date
}

export const seasonalities: Seasonality[] = [
  {
    name: 'Black Friday',
    imageHeaderDesktop: '',
    imageHeaderMobile: '',
    imageFlyer: '/img/flyer-header.png',
    imageFlyerFooter: '/img/flyer-footer.png',
    backgroundColor: '#7B35C9',
    headerColor: themeClubbi.palette.brandBlack.main,
    hoverColor: themeClubbi.palette.brandPurple[80],
    footerColor: '#F4BA01',
    iconColor: themeClubbi.palette.brandPurple[60],
    shadow: '',
    dateTimeToStart: new Date(START_ESQUENTA_BF),
    dateTimeToExpire: new Date(END_BLACK_FRIDAY),
  },
]

export const standard: Seasonality = {
  name: 'default',
  imageHeaderDesktop: '',
  imageHeaderMobile: '',
  imageFlyer: '/img/flyer-header.png',
  imageFlyerFooter: '/img/flyer-footer.png',
  backgroundColor: '#7B35C9',
  headerColor: themeClubbi.palette.brandPurple[60],
  hoverColor: themeClubbi.palette.brandPurple[80],
  footerColor: '#F4BA01',
  iconColor: themeClubbi.palette.brandPurple[60],
  shadow: '',
  dateTimeToStart: new Date(2020, 10, 21),
  dateTimeToExpire: new Date(2060, 10, 21),
}

export const getSeasonStyle = (): Seasonality => {
  const today = new Date()
  const season = seasonalities.find(
    (event) => today >= event.dateTimeToStart && today <= event.dateTimeToExpire
  )
  return season ? season : standard
}
